import React from 'react'
import { Carousel, News, NewsCard } from './../../components'
import { getNews } from './../../core/api/news-provider'
import { Row, Col, Container } from 'react-bootstrap'

const Noticias = () => {

    const [newsData, setNewsData] = React.useState()

    React.useEffect(() => {
        getNews().then((res) => setNewsData(res.data))
    }, [])

    return (
        <>
            {
                newsData && (
                    <>
                        <Carousel slides={newsData.slides}/>

                        <Container fluid>
                            <Row className='my-5'>
                                <Col xs={12} className='px-0'>
                                    <News
                                        title={newsData.featuredNews.content_group.title}
                                        text={newsData.featuredNews.content_group.text}
                                        date={newsData.featuredNews.content_group.date}
                                        image={newsData.featuredNews.image}
                                        button={newsData.featuredNews.content_group.button}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col 
                                    xs={12}
                                    md={{
                                        span: 10,
                                        offset: 1
                                    }}
                                >
                                    <Row className='justify-content-start my-5'>
                                        {
                                            newsData.news.map(item => (
                                                <Col xl={4} lg={6} md={12} className='mb-5'>
                                                    <NewsCard
                                                        title={item.title}
                                                        image={item.image}
                                                        content={item.content}
                                                        date={item.date}
                                                    />
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                </Col>
                            </Row>
                        </Container>

                    </>
                )
            }
        </>
    )
}

export default Noticias